import { axios } from '@/services/axios';

export const updateTrunkType = (trunkTypeData) => {
    return axios.put('/trunktype', trunkTypeData);
};
